module.exports = __webpack_public_path__ + "amex.837c35.svg";